module.exports = __webpack_public_path__ + "img/document-download.3835c750.svg";